import { FieldDataType } from '@feathr/blackbox';

import {
  BooleanCell,
  DateCell,
  ListCell,
  NumberCell,
  type TCell,
  TextCell,
} from './DataTableCells';

/**
 * Maps a custom field's data type to the table-cell renderer used for it.
 *
 * This lives in its own module on purpose. DataTableCells.tsx exports React
 * component factories, so react-refresh treats it as a Fast Refresh boundary;
 * colocating this non-component `Map` there let a hot update swap the export
 * binding, so `fieldTypeToCellMap.get` intermittently became undefined and the
 * People/Community table crashed with "fieldTypeToCellMap.get is not a function".
 * A component-free module reloads cleanly and always stays a real `Map`.
 */
export const fieldTypeToCellMap = new Map<FieldDataType, TCell>([
  [FieldDataType.str, TextCell],
  [FieldDataType.bool, BooleanCell],
  [FieldDataType.date, DateCell],
  [FieldDataType.float, NumberCell],
  [FieldDataType.int, NumberCell],
  [FieldDataType.list, ListCell],
]);
